
<template>
  <div class="modal fade" id="contactForm" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="formSent">
            <div v-if="statusText" class="alert alert-success" role="alert">{{ statusText }}</div>
            <div v-if="statusError" class="alert alert-danger" role="alert">{{ statusError }}</div>
          </div>
          <form v-else>
            <div class="mb-3">
              <label class="form-label">Mitteilung</label>
              <textarea id="contactFormComment" :class="{'is-invalid': !validateForm()}" class="form-control" rows="3" placeholder="Ihre Mitteilung" v-model="formComment"></textarea>
              <div class="invalid-feedback">Dieses Feld wird benötigt.</div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button v-if="formSent" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Schließen</button>
          <button v-else @click="sendForm" type="button" class="btn btn-secondary">Abschicken</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from "vue";
import { useStore } from "vuex";

const store = useStore();

const formSent = ref(false);

const statusError = computed(() => {
  return store.getters.rwmFormResponseError;
});

const statusText = computed(() => {
  return store.getters.rwmFormResponseMessage;
});

const formComment = ref("");

const formCommentField = ref(null);

const validateForm = () => formComment.value.trim() !== "";

const sendForm = async() => {
  if (validateForm()) {
    formSent.value = true;
    await store.dispatch('sendRwmForm', {
      comment: formComment.value,
    });
  } else {
    formCommentField.value?.focus();
  }
}


onMounted(() => {
  const modalForm = document.getElementById('contactForm')
  modalForm.addEventListener('hidden.bs.modal', () => {
    formSent.value = false;
    formComment.value = "";
  });
  modalForm.addEventListener('shown.bs.modal', () => {
    formCommentField.value = document.getElementById('contactFormComment');
    formCommentField.value?.focus();
  });
})

</script>

<style scoped>

</style>